import { Box } from "@mui/material";
import MuiDialogContentText from "@mui/material/DialogContentText";
import MuiDialogTitle from "@mui/material/DialogTitle";
import styled from "styled-components";

export const DialogContentText = styled(MuiDialogContentText)`
  display: flex;
  color: #898a8d;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const DialogTitle = styled(MuiDialogTitle)`
  color: #263238;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: "NotoSans-SemiBold";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const ActionWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;
